import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';
import { lockBodyScroll, unlockBodyScroll } from '../bodyScrollLock';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
  static targets = ['button', 'aside'];

  static values = {
    open: Boolean,
  };

  openValueChanged() {
    this.buttonTarget.setAttribute('aria-expanded', this.openValue);
    document.body.classList.toggle('has-course-overlay', this.openValue);
  }

  connect() {
    useClickOutside(this);
  }

  toggle() {
    this.openValue = !this.openValue;

    if (this.openValue) {
      lockBodyScroll(this.asideTarget);
    } else {
      unlockBodyScroll(this.asideTarget);
    }
  }

  close() {
    this.openValue = false;
    unlockBodyScroll(this.asideTarget);
  }

  clickOutside() {
    this.close();
  }
}